import React, { useEffect, useState } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import VargForm from './pages/varg/components/VargForm';
import apiService from './services/ApiService';
import InactiveVarg from './pages/varg/InactiveVarg';
import { Varg } from './pages/varg/types';
import ExamPage from './pages/examportal/ExamPage';
import ExamSubmittedPage from './pages/examportal/ExamSubmittedPage';
import ExamDashboardPage from './pages/dashboard/ExamDashboardPage';
import LoginPage from './pages/login/LoginPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { SessionConflictBanner } from './components/SessionConflictBanner';
import '@mantine/dates/styles.css';

// Mapping route segments to actual varg names
const routeToVargNameMap: Record<string, string> = {
  NirogatvaVarg: 'Nirogatva Yog Varg',
  PakshikVarg: 'Pakshik Yog Varg',
  // Add more mappings as needed
};

const VargPage: React.FC<{ vargs: Varg[] }> = ({ vargs }) => {
  const { vargRoute } = useParams<{ vargRoute: string }>();
  const vargName = routeToVargNameMap[vargRoute || ''];

  if (!vargName) return <div>Invalid route.</div>;

  const matchedVarg = vargs.find((v) => v.vargName === vargName);

  if (!matchedVarg) return <div>Varg not found.</div>;

  return matchedVarg.active ? (
    <VargForm varg={matchedVarg} />
  ) : (
    <InactiveVarg vargName={vargName} />
  );
};

const VargRouteWrapper: React.FC = () => {
  const [vargs, setVargs] = useState<Varg[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiService.request<any>(
      'get',
      'jsyogvarg/vargdata',
      null,
      {},
      (response) => {
        if (response && Array.isArray(response.data)) {
          setVargs(response.data);
        } else {
          setError('Expected array in "data", but got something else.');
        }
        setLoading(false);
      },
      () => {
        setError('Failed to fetch Varg data.');
        setLoading(false);
      }
    );
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return <VargPage vargs={vargs} />;
};

const App: React.FC = () => {
  return (
    <>
      {/* Session-conflict overlay — shown globally when server invalidates this session */}
      <SessionConflictBanner />

      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <ExamDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/exam"
          element={
            <ProtectedRoute>
              <ExamPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/exam/submitted"
          element={
            <ProtectedRoute>
              <ExamSubmittedPage />
            </ProtectedRoute>
          }
        />
        <Route path="/:vargRoute" element={<VargRouteWrapper />} />
        <Route path="*" element={<div>Page not found.</div>} />
      </Routes>
    </>
  );
};

export default App;
